import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { TradeContractState } from "./model";

let state: TradeContractState = {
  tradeContract: {
    id: '',
    baseId: '',
    status: 'preparing',
    name: '',
    description: '',
    issuerTerminalId: '',
    recipientTerminalId: '',
    proposerTerminalId: '',
    responderTerminalId: '',
    targetTerminalId: '',
    producerTerminalId: '',
    consumerTerminalId: '',
    sendType: 'push',
    contractType: 'draft',
    expireDate: '',
    unchangeable: false,
    commonDictionaryId: '',
    producerDataProfileId: '',
    consumerDataProfileId: '',
    producerServiceProfileId: '',
    consumerServiceProfileId: '',
    producerProcessProfileId: '',
    consumerProcessProfileId: '',
    producerEventProfileIds: [],
    consumerEventProfileIds: [],
    dataPropertyProfileMaps: [],
    contractProfileTemplateId: '',
    startDatetime: '',
    endDatetime: '',
    createdAt: '',
    updatedAt: '',
    companionOwnerId: '',
    companionOwnerName: '',
    companionTerminalId: '',
    companionTerminalName: '',
    serviceType: 'producer',
    dataImplementation: {
      id: '',
      name: '',
      description: '',
      localId: '',
      remarks: '',
      controllerId: '',
      publishing: false,
      dataComponentModelId: '',
      dataComponentModelName: '',
      processOperationImplementationsCount: 0,
      parameterDescription: '',
    },
    dataComponentModelName: '',
    dataComponentModelDictionaryName: '',
    previousTradeContractId: null,
    consumerDataComponentModelName: '',
    producerDataComponentModelName: '',
  },
  requestingTradeContracts: [],
  tradingTradeContracts: [],
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} as Module<TradeContractState, RootStateType>;
